<script setup lang="ts">
import type { VisibleMagazineListItemModel } from '@develop/ia-api-library'

const props = defineProps<{
  magazine: VisibleMagazineListItemModel
  isCarousel?: boolean
}>()

defineEmits<{
  (e: 'openMagazine', value: number): void
}>()

const { t } = useTranslation()

const getFormattedDate = (date: string) => {
  const result = new Date(date)
  return result.toLocaleDateString('de', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

const width = computed(() => (props.isCarousel ? 'w-full' : 'w-full xs:w-148px sm:w-203px'))
const height = computed(() => (props.isCarousel ? 'h-full' : 'h-200px sm:h-252px'))
</script>

<template>
  <div
    :id="`magazine-${magazine.id}`"
    flex="~ col gap-4 lt-sm:col lt-sm:gap-6"
    content-center
    @click="$emit('openMagazine', magazine.id)"
  >
    <div>
      <NuxtImg
        :src="magazine.coverPage"
        lt-sm:mx-auto
        p="2"
        class="rounded-lg border-1 border-transparent hover:cursor-pointer hover:border-grey-800"
        :class="[{ '!border-grey-200': !isCarousel }, width, height]"
      />
    </div>
    <div
      flex="~ col"
      items-center
    >
      <IaHeading
        :level="8"
        font-700
        as="h3"
        w="80%"
        truncate
        ws-break-spaces
        text-center
      >
        {{ magazine.title }}
      </IaHeading>
      <IaParagraph
        color="grey-600"
        w="80%"
        text-center
      >
        {{ t('epaper.magazinePage.editionOf') }} {{ getFormattedDate(magazine.publishedAt) }}
      </IaParagraph>
    </div>
  </div>
</template>
